
import React from "react";
import EscapeButton from "../EscapeButton";

const HeroSection: React.FC = () => {
  return (
    <section className="min-h-screen flex flex-col items-center justify-center text-center px-4 py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-black">
        {/* Efeito de luz circular animado */}
        <div className="absolute inset-0 bg-gradient-radial from-white/5 to-transparent animate-pulse" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.03)_0%,_transparent_50%)] animate-[spin_20s_linear_infinite]" />
        
        {/* Background image with overlay */}
        <div className="absolute inset-0 opacity-30">
          <img 
            src="/lovable-uploads/137d40c6-215e-42b3-a788-dcaf4b092f08.png" 
            alt="Atleta em treino" 
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
      </div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold mb-8 tracking-tight animate-fade-in">
          ESCAPE CLUB
        </h1>
        <p className="text-xl md:text-2xl font-medium mb-4 animate-fade-in" style={{ animationDelay: "0.2s" }}>
          A Comunidade Que Destrói o Comum
        </p>
        <p className="text-lg opacity-80 mb-12 animate-fade-in" style={{ animationDelay: "0.4s" }}>
          Escape do óbvio. Viva de verdade.
        </p>
        <div className="animate-fade-in" style={{ animationDelay: "0.6s" }}>
          <EscapeButton size="large">🔥 Quero escapar agora</EscapeButton>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
